module.exports = __webpack_public_path__ + "img/dd1.6225c720.png";